//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
let d=[[[0,"DynamicRayTracedStudioTilingQuality",1,1],[0,"RayTracedStudioDisplayGamma",1,1],[0,"RayTracedStudioStaticImageDotsPerInch",1,1],[0,"RayTracedStudioStaticImageDoubleHeight",1,1],[0,"RayTracedStudioStaticImageDoubleWidth",1,1],[0,"RayTracedStudioStaticImageFileFormat",1,1],[0,"RayTracedStudioStaticImageLockAspectRatio",1,1],[0,"RayTracedStudioStaticImageOrientation",1,1],[0,"RayTracedStudioStaticImagePixelHeight",1,1],[0,"RayTracedStudioStaticImagePixelWidth",1,1],[0,"RayTracedStudioStaticImageResolution",1,1],[0,"RayTracedStudioStaticImageSize",1,1],[0,"RayTracedStudioStaticImageUnits",1,1],[0,"StaticAntialiasing",1,1],[0,"StaticRayTracedStudioQuality",1,1],[0,"StaticRayTracedStudioRenderDepth",1,1],[0,"StationaryAntialiasing",1,1],[0,"StationaryRayTracedStudioQuality",1,1],[0,"StationaryRayTracedStudioshowStatusIndicator",1,1]],[],[]];
SPLM.Display.RayTracedStudioEditorBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.RayTracedStudioEditorBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.RayTracedStudioEditorBuilder.DynamicRayTracedStudioTilingQualityType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low"});

SPLM.Display.RayTracedStudioEditorBuilder.StationaryRayTracedStudioQualityType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low"});

SPLM.Display.RayTracedStudioEditorBuilder.StationaryAntialiasingType = Object.freeze({
    "Medium" : "Medium", "Low" : "Low", "None" : "None"});

SPLM.Display.RayTracedStudioEditorBuilder.StaticRayTracedStudioQualityType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low", "UserDefined" : "UserDefined"});

SPLM.Display.RayTracedStudioEditorBuilder.StaticAntialiasingType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low", "None" : "None"});

SPLM.Display.RayTracedStudioEditorBuilder.RayTracedStudioStaticImageFileFormatType = Object.freeze({
    "Tif" : "Tif", "Png" : "Png", "Jpg" : "Jpg"});

SPLM.Display.RayTracedStudioEditorBuilder.RayTracedStudioStaticImageUnitsType = Object.freeze({
    "Pixels" : "Pixels", "Millimeters" : "Millimeters", "Inches" : "Inches"});

SPLM.Display.RayTracedStudioEditorBuilder.RayTracedStudioStaticImageSizeType = Object.freeze({
    "RenderWindow" : "RenderWindow", "UserDefined" : "UserDefined"});

SPLM.Display.RayTracedStudioEditorBuilder.RayTracedStudioStaticImageOrientationType = Object.freeze({
    "Landscape" : "Landscape", "Portrait" : "Portrait"});

SPLM.Display.RayTracedStudioEditorBuilder.RayTracedStudioStaticImageResolutionType = Object.freeze({
    "High" : "High", "Medium" : "Medium", "Low" : "Low", "UserDefined" : "UserDefined"});

export default SPLM;